import type { NavigationGuard } from 'vue-router'
import { EPage } from '@/shared/enum/page.enum'
import { profiledUserGuard } from '@/router/mce/guards/profiled-user.guard'
import { rootPathGuard } from '@/router/mce/guards/root-path.guard'
import { mandatoryBillingGuard } from '@/router/mce/guards/mandatory-billing.guard'
import { generateFolioGuard } from '@/router/guards/generate-folio.guard'
import { resultGuard } from '@/router/mce/guards/result.guard'

export const ROUTES_GUARDS: Record<EPage, NavigationGuard[]> = {
  [EPage.BLANK]: [rootPathGuard],
  [EPage.BUY_RECHARGES]: [],
  [EPage.GENERIC_ERROR]: [],
  [EPage.GENERATE_FOLIO]: [generateFolioGuard],
  [EPage.HISTORY]: [],
  [EPage.INTERNET_ON_DEMAND]: [],
  [EPage.INVOICE]: [mandatoryBillingGuard],
  [EPage.LANDING]: [],
  [EPage.LATE_PAYMENT]: [],
  [EPage.MAINTENANCE]: [],
  [EPage.MICROCREDITS]: [],
  [EPage.NOT_FOUND]: [],
  [EPage.PACKAGES]: [profiledUserGuard],
  [EPage.PAYMENT_FORM]: [],
  [EPage.PROFILE]: [],
  [EPage.PROMOTIONS]: [],
  [EPage.RESULT]: [resultGuard],
  [EPage.ROOT]: [],
  [EPage.SEND_RECHARGES]: [],
  [EPage.SHORT_LINK]: [],
  [EPage.TERMS]: [],
  [EPage.TURN_ON_3G]: [],
  [EPage.EXIT]: []
}
